import { Seo } from "@/components/Seo";
import GalleryPage from "@/pages/GalleryPage";

export default function ArtPage() {
  return (
    <>
      <Seo
        title="Meaningful Art to Beautify Spaces — The Delta DL Enterprise, LLC Collection"
        description="A veteran-owned collection of expressive wall art by Dennis Louden alongside AI-generated designs developed through his creative direction and selection. Custom original pieces available for clients."
        path="/art"
      />
      <GalleryPage
        only="art"
      overline="The Delta DL Enterprise, LLC Collection"
      collectionTag="A Veteran-Owned Business"
      heading="Meaningful Art to Beautify Spaces."
      subtitle="Transform your home or office with expressive wall art inspired by humanity, nature, and imagination. Explore artwork created by Dennis Louden alongside AI-generated designs developed through his creative direction and selection."
      note="From bold conversation pieces to calming compositions, discover art that reflects your style and brings character to your space. Each canvas is printed to order, especially for you. Individual listings describe how each artwork was created. Custom original pieces are available — share your vision, and Dr. Louden will create a piece especially for you. Find the piece that speaks to you."
      noteAction={{ label: "Shop the Collection", href: "#art-collection" }}
    />
    </>
  );
}
